import { SdkContext } from '../internal'
import type { Poll, PollVoter } from '@/types/poll'

/** F-41: polls on posts. Creating one goes through `status.create`/`content.create` with `poll`. */
export class PollsResource {
  constructor(private ctx: SdkContext) {}

  async get(id: string): Promise<Poll> {
    return this.ctx.call({ httpMethod: 'GET', path: '/polls/{id}' }, { id })
  }

  /** Votes, or replaces the vote. Returns the poll with the counts. */
  async vote(id: string, optionIds: string[]): Promise<Poll> {
    return this.ctx.call({ httpMethod: 'POST', path: '/polls/{id}/vote', hasBody: true }, { id, body: { optionIds } })
  }

  /** Takes the vote back while the poll is open. */
  async retractVote(id: string): Promise<Poll> {
    return this.ctx.call({ httpMethod: 'DELETE', path: '/polls/{id}/vote' }, { id })
  }

  /** Staff only. `options` is the whole list: `{ id, text }` keeps, `{ text }` adds, a missing one is removed. */
  async update(
    id: string,
    body: { options?: { id?: string; text: string }[]; allowMultiple?: boolean; closesAt?: string | null }
  ): Promise<Poll> {
    return this.ctx.call({ httpMethod: 'PUT', path: '/polls/{id}', hasBody: true }, { id, body })
  }

  /** Staff only. Closing cannot be undone. */
  async close(id: string): Promise<Poll> {
    return this.ctx.call({ httpMethod: 'POST', path: '/polls/{id}/close', hasBody: true }, { id, body: {} })
  }

  /** Staff only: who voted, newest first, optionally for one option. */
  async votes(
    id: string,
    params: { optionId?: string; page?: number; limit?: number } = {}
  ): Promise<{ items: PollVoter[]; pagination?: { page: number; totalPages: number; total: number; hasNext?: boolean } }> {
    return this.ctx.call({ httpMethod: 'GET', path: '/polls/{id}/votes' }, { id, query: params })
  }
}
